import { createAction, props } from '@ngrx/store';
import { CustomWindowSettings } from 'app/core/services/custom-window-service/custom-window.service';

export const openWindow = createAction(
  '[Window - Effect] Open Window',
  props<{ windowParams: CustomWindowSettings }>()
);

export const closeWindow = createAction(
  '[Dossier - Effect] Close window'
);

export const closeWindowAndOpenNext = createAction(
  '[Dossier - Effect] Close current window and open next window',
  props<{ windowParams: CustomWindowSettings }>()
);
